import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryMergeOrdersEvent } from "../../../common/types/order-details-history-entry-event";

type OrderDetailsHistoryEntryMergeOrdersContentProps = {
  event: OrderDetailsHistoryEntryMergeOrdersEvent;
};

const OrderDetailsHistoryEntryMergeOrdersContentComponent: FC<
  OrderDetailsHistoryEntryMergeOrdersContentProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().mergeOrdersEntry;

  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryMergeOrdersContentComponent;
